<app-panel panelTitleIcon="../../../assets/icones/ic_timeline_docnecessaria.svg" panelTitleSmall="Relação de" panelTitle="Fichas"
    padding="no-padding" [loading]="loading" [noData]="!labels || labels.length <= 0" noDataText="Sem fichas">

    <app-btn-group *ngIf="labels?.length > 0" title="Visão">
        <button type="button" (click)="agruparPorData()" class="btn btn-primary active" [ngClass]="{'active': agrupamento.descricao === 'data'}">Por Data</button>
        <button type="button" (click)="agruparPorLoja()" class="btn btn-primary" [ngClass]="{'active': agrupamento.descricao === 'loja'}">Por Loja</button>
    </app-btn-group>

    <app-record [periodo]="periodo" *ngFor="let label of labels" [label]="label" [propostas]="propostasPorLabel(label)"></app-record>
</app-panel>